import { render, staticRenderFns } from "./environmentallist.vue?vue&type=template&id=1f627bfe&scoped=true&"
import script from "./environmentallist.vue?vue&type=script&lang=js&"
export * from "./environmentallist.vue?vue&type=script&lang=js&"
import style0 from "./environmentallist.vue?vue&type=style&index=0&id=1f627bfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f627bfe",
  null
  
)

export default component.exports